<template>
    <div class="section text-center mt-1" v-if="loading_list">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
    <div class="section pt-0 mt-0" v-if="!loading_list">
        <div class="listed-detail mt-1 page-title">
            <h3 class="text-center mt-1 mal-text custom-title">{{ responseData.campign.name }}</h3>
        </div>
    </div>
    <div class="section mb-1 mt-1" v-if="!loading_list && responseData.permissions.report">
        <div class="transactions">
            <a :href="'/#/call-follow-up-report/' + responseData.campign.id" class="item">
                <div class="detail">
                    <img :src="'assets/img/telephone.png'" alt="img" class="image-block imaged w48">
                    <div>
                        <strong class="text-primary">Calling Report</strong>
                        <p class="mal-text">റിപ്പോർട്ട് പേജിലേക്ക് പോകാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക</p>
                    </div>
                </div>
                <div class="right">
                    <div class="price text-primary"><ion-icon name="chevron-forward-outline"></ion-icon></div>
                </div>
            </a>
        </div>
    </div>
    <div class="section mb-1" v-if="!loading_list">
        <div class="row mt-1">
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ആകെ നമ്പറുകൾ</div>
                    <div class="value text-success">{{ responseData.target ? responseData.target : '0' }}</div>
                </div>
            </div>
            <div class="col-6">
                <div class="stat-box">
                    <div class="title mal-text">ബാക്കിയുള്ളത്(<a href="javascript:void(0)" data-bs-toggle="modal"
                            data-bs-target="#pendingListModel">List</a>)</div>
                    <div class="value text-danger">{{ responseData.balance ? responseData.balance : '0' }}</div>
                </div>
            </div>
        </div>
    </div>
    <div id="search" v-if="!loading_list && !$route.params.mobile">
        <form class="search-form">
            <div class="row">
                <div class="input-group form-group" style="width:70% !important;padding-right: 0px;">
                    <input type="number" placeholder="Search Mobile..." class="form-control" maxlength="99999999999" focus
                        v-model="search_qry" aria-describedby="basic-addon3"
                        style="border: 1px solid #1a418c; border-radius: 10px;" />
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-success me-1" @click="search()">
                        <ion-icon name="search-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
                <div class="form-group" style="width:12% !important;">
                    <button type="button" class="btn btn-icon btn-outline-primary me-1" @click="displayAll">
                        <ion-icon name="list-outline" role="img" class="md hydrated"
                            aria-label="newspaper outline"></ion-icon>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div class="section pt-0 mt-0" v-if="searchResponse.message">
        <div class="listed-detail mt-1">
            <h4 class="text-center text-danger mt-1 mal-text">{{ searchResponse.message }}</h4>
        </div>
    </div>
    <ul class="listview image-listview inset text mb-2" v-if="!loading_list && !searchResponse.contact && !search_loading">
        <li v-for="(member_list, index) in responseData.all_contacts" v-bind:key="member_list.id"
            :style="{ 'background-color': background }">
            <a href="javascript:void(0)" class="item">
                <span class="sl-no">{{ index + 1 }}</span>
                <div class="avatar-section">
                    <a href="javascript:void(0)">
                        <img src="assets/img/sample/avatar/avatar1.png" alt="avatar" class="image">
                        <span class="button verified" v-if="member_list.status == 'Completed'">
                            <ion-icon name="checkmark-outline"></ion-icon>
                        </span>
                        <span class="button not-verified" v-if="member_list.status != 'Completed'">
                            <ion-icon name="close-outline"></ion-icon>
                        </span>
                    </a>
                </div>
                <div class="in">
                    <div class="min-width-50">
                        <header class="text-info" v-if="member_list.registered == 'Y'">Registered <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span></header>
                        <header class="text-danger" v-else>Not Registered <span v-if="member_list.self_confirmation_status == 'Y'" class="text-info">| Self Confirmed</span></header>
                        <!-- <header>User</header> -->
                        <b class="text-primary"> {{ member_list.name }} -{{ member_list.contact_id }} </b>
                        <footer
                            :class="member_list.calling_status_value ? member_list.calling_status_value.item_value_display : 'text-primary'">
                            {{
                                member_list.calling_status_value ? member_list.calling_status_value.name_mal :
                                member_list.calling_status
                            }}
                        </footer>
                    </div>
                    <div class="card-button dropdown">
                        <button type="button" class="btn btn-link btn-icon" data-bs-toggle="modal"
                            :data-bs-target="'#actionSheetInset' + member_list.id" @click="showActionModel">
                            <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                        </button>
                    </div>

                    <!-- Default Action Sheet Inset -->
                    <div class="modal fade action-sheet" :id="'actionSheetInset' + member_list.id" tabindex="-1"
                        role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Action</h5>
                                </div>
                                <div class="modal-body">
                                    <ul class="action-button-list">
                                        <li v-if="responseData.campign.reporting_campaign_id">
                                            <a href="javascript:void(0)" class="btn btn-list text-info"
                                                data-bs-dismiss="modal" @click="gotoReport(member_list.mobile)">
                                                <span>
                                                    <ion-icon name="list-outline"></ion-icon> Goto Report
                                                </span>
                                            </a>
                                        </li>
                                        <li>
                                            <a :href="'tel:' + member_list.mobile" class="btn btn-list text-primary">
                                                <span>
                                                    <ion-icon name="call-outline"></ion-icon> Call
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="member_list.mobile">
                                            <a :href="'https://wa.me/' + mobileToWhatsapp(member_list.mobile) + '?text='"
                                                class="btn btn-list text-success">
                                                <span>
                                                    <ion-icon name="logo-whatsapp"></ion-icon> Whatsapp
                                                </span>
                                            </a>
                                        </li>
                                        <li v-if="!$route.params.mobile">
                                            <a href="javascript:void(0)" class="btn btn-list text-primary"
                                                data-bs-dismiss="modal" @click="gotoEdit(member_list.mobile)">
                                                <span>
                                                    <ion-icon name="pencil-outline"></ion-icon> View/Edit
                                                </span>
                                            </a>
                                        </li>

                                        <li class="action-divider"></li>
                                        <li>
                                            <a href="#" class="btn btn-list text-danger" data-bs-dismiss="modal">
                                                <span>
                                                    <ion-icon name="close-outline"></ion-icon> Cancel
                                                </span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- * Default Action Sheet Inset -->
                </div>
            </a>
        </li>
    </ul>
    <div class="section pt-0 mt-1 pb-2" v-if="searchResponse.contact && !search_loading">
        <div class="card">
            <div class="card-body">
                <Form @submit="handleRegistration" :validation-schema="schema">

                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="id">
                                ID
                            </label>
                            <Field type="text" disabled class="form-control" name="id" v-model="formData.id"
                                placeholder="ID" autocomplete="off" />
                            <ErrorMessage name="id" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="id">
                                വിസ്‌ഡം മെമ്പർ ആണോ?
                            </label>
                            <Field type="text" disabled class="form-control" name="wisdom_member"
                                v-model="formData.wisdom_member" placeholder="" autocomplete="off" />
                            <ErrorMessage name="wisdom_member" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="name">
                                പേര്
                            </label>
                            <Field type="text" class="form-control" name="name" v-model="formData.name" placeholder="Name"
                                autocomplete="off" />
                            <ErrorMessage name="name" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="mobile">
                                മൊബൈൽ
                            </label>
                            <Field type="number" class="form-control" name="mobile" v-model="formData.mobile"
                                placeholder="0000000000" autocomplete="off" />
                            <ErrorMessage name="mobile" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="status">
                                വിളിയുടെ status
                            </label>
                            <Field as="select" class="form-control custom-select" id="status" name="status"
                                v-model="formData.status">
                                <option value="" :disabled="true" selected>Select Status</option>
                                <option v-for="status in status_list" v-bind:key="status.id" v-bind:value="status.id">
                                    {{ status.name_mal }}
                                </option>
                            </Field>
                            <ErrorMessage name="status" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="mobile2">
                                മൊബൈൽ 2
                            </label>
                            <Field type="number" class="form-control" name="mobile2" v-model="formData.mobile2"
                                placeholder="0000000000" autocomplete="off" />
                            <ErrorMessage name="mobile2" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label text-primary" for="sex">
                                Sex</label>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Male" name="Sex" id="sex_1"
                                    v-model="formData.sex" />
                                <label class="form-check-label" for="sex_1">Male &nbsp;</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input type="radio" class="form-check-input" value="Female" name="Sex" id="sex_2"
                                    v-model="formData.sex" />
                                <label class="form-check-label" for="sex_2">Female &nbsp;</label>
                            </div>
                            <ErrorMessage name="sex" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="district">
                                ജില്ല
                            </label>
                            <Field as="select" class="form-control custom-select" id="district" name="district"
                                v-model="formData.district">
                                <option value="" :disabled="true" selected>Select District</option>
                                <option v-for="district in district_list" v-bind:key="district.id"
                                    v-bind:value="district.id">
                                    {{ district.name }}
                                </option>
                            </Field>
                            <ErrorMessage name="place" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="place">
                                സ്ഥലം
                            </label>
                            <Field type="text" class="form-control" name="place" v-model="formData.place"
                                placeholder="Place" autocomplete="off" />
                            <ErrorMessage name="place" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic">
                        <div class="input-wrapper">
                            <label class="label mal-text text-primary" for="comments">
                                അവർ പറഞ്ഞ അഭിപ്രായങ്ങൾ, നിർദ്ദേശങ്ങൾ
                            </label>
                            <Field type="text" class="form-control" name="comments" v-model="formData.comments"
                                placeholder="---" autocomplete="off" />
                            <ErrorMessage name="comments" class="error-feedback" />
                        </div>
                    </div>
                    <div class="form-group basic" v-for="(questian, index) in responseData.questians"
                        v-bind:key="questian.id" :class="'col-' + questian.field_column_size" style="display: inline-block;">
                        <div class="input-wrapper" v-if="questian.question_type == 'DATE'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <Field type="date" class="form-control" :name="'questian_air[' + index + ']'" placeholder="..."
                                v-model="questians_responses[index]" :required="questian.question_validations == 'Y'" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <div class="input-wrapper"
                            v-else-if="questian.question_type == 'TX' || questian.question_type == 'TXT'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <Field type="text" class="form-control" :name="'questian_air[' + index + ']'" placeholder="..."
                                v-model="questians_responses[index]" :required="questian.field_mandatory == 'Y'" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <div class="input-wrapper"
                            v-else-if="questian.question_type == 'NUM'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <Field type="number" class="form-control" :name="'questian_air[' + index + ']'" placeholder="..."
                                v-model="questians_responses[index]" :required="questian.field_mandatory == 'Y'" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                        <div class="input-wrapper" v-else-if="questian.question_type == 'SB'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <select as="select" class="form-control custom-select" v-model="questians_responses[index]"
                                :required="questian.question_validations == 'Y'" :name="'questian_air[' + index + ']'"
                                id="select4">
                                <option value>---Select---</option>
                                <option v-for="option in convertToJson(questian.question_options)" v-bind:value="option"
                                    v-bind:key="option">{{ option }}</option>
                            </select>
                        </div>
                        <div class="input-wrapper" v-if="questian.question_type == 'DISPLAY'">
                            <label class="label questians-label text-primary mal-text" :for="'field' + questian.id">
                                <b>{{ questian.question_text }}</b>
                            </label>
                            <span class="badge" :class="questians_responses[index] == 'Yes'?'badge-success':questians_responses[index] == 'No'?'badge-danger':'badge-primary'" v-if="questian.field_style == 'badge'">
                                {{ questians_responses[index] }}
                            </span>
                            <Field v-if="questian.field_style != 'badge'" type="text" :disabled="true" class="form-control" :name="'questian_air[' + index + ']'"
                                placeholder="..." v-model="questians_responses[index]"
                                :required="questian.question_validations == 'Y'" />
                            <i class="clear-input">
                                <ion-icon name="close-circle"></ion-icon>
                            </i>
                        </div>
                    </div>
                    <button type="submit" class="btn btn-primary btn-block btn-lg" :disabled="btn_loading">
                        <span v-show="btn_loading" class="spinner-border spinner-border-sm"></span>
                        <span>Save</span>
                    </button>
                </Form>
            </div>
        </div>
    </div>
    <div class="modal fade action-sheet" id="pendingListModel" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Pending List</h5>
                </div>
                <div class="modal-body">
                    <div class="action-sheet-content">
                        <ul class="listview image-listview inset">
                            <li v-for="(member, index) in this.pending_contacts" v-bind:key="member.id">
                                <a href="javascript:void(0)" class="item">
                                    <span class="sl-no">{{ (index + 1) }}</span>
                                    &nbsp;&nbsp;
                                    <div class="in">
                                        <div>
                                            <header class="text-info" v-if="member.registered == 'Y'">Registered</header>
                                            <b class="list-item-text">{{ member.name }}({{ member.contact_id }})</b>
                                            <footer>
                                                <span class="text-primary">
                                                    {{ member.mobile ? member.mobile : 'No Number' }}
                                                </span>
                                            </footer>
                                        </div>
                                        <div class="card-button" v-if="!$route.params.mobile">
                                            <button type="button" data-bs-dismiss="modal" class="btn btn-link btn-icon"
                                                @click="gotoEdit(member.mobile)">
                                                <ion-icon name="eye-outline"></ion-icon>
                                            </button>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                        <div class="form-group basic">
                            <button type="button" data-bs-dismiss="modal"
                                class="btn btn-secondary btn-cancel btn-lg col-12">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
    <dialog-model :message="dialog_message" :action_method="dialog_action" :action_method_params="dialog_action_params"
        ref="dialog_model"></dialog-model>
</template>

<script>
import {
    Form,
    Field,
    ErrorMessage
} from "vee-validate";
import UserService from "../../services/user.service";
import $ from "jquery";
import AlertModel from "./../layouts/AlertModel.vue";
import DialogModel from "./../layouts/DialogModel.vue";
export default {
    name: "Admin List",
    props: {
        unit_id: null,
        permissions: Object,
    },
    components: {
        Form,
        Field,
        ErrorMessage,
        AlertModel,
        DialogModel,
    },
    data() {
        return {
            btn_loading: false,
            search_loading: false,
            loading: false,
            loading_list: false,
            alert_type: "",
            alert_message: "",
            dialog_message: "",
            dialog_action: "",
            directory_type_list: [],
            profession_list: [],
            skilset_list: [],
            adarsham_list: [],
            qualification_list: [],
            wisdom_programs_list: [],
            formData: {
                directory_type: [],
                wisdom_programs: [],
                profession: [],
                skilset: [],
                adarsham: [],
                qualification: [],
                name: '',
                mobile: '',
                mobile2: '',
                whatsapp: '',
                age: '',
                remarks: '',
                district: '',
                place: '',
                comments: '',
                status: '',
                wisdom_member: ''
            },
            questians_responses: [],
            responseData: {
                campign: [],
                questians: [],
                all_contacts: [],
                permissions: []
            },
            searchResponse: {
                contact: ''
            },
            pending_contacts: [],
            district_list: [],
            status_list: [],
        };
    },

    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        childLength() {
            return parseInt(this.formData.lessthan_16_count);
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace("/");
        } else {
            this.$root.updateParent("Loading...");
            this.getComboboxValues('CALL_CAMPAIGN_STATUS');
            // this.getComboboxValues('YOUTH_DIRECTORY_PROFESSION');
            // this.getComboboxValues('YOUTH_DIRECTORY_QUALIFICATION');
            // this.getComboboxValues('YOUTH_DIRECTORY_SKILSET');
            // this.getComboboxValues('YOUTH_DIRECTORY_ADARSHAM');
            // this.getComboboxValues('YOUTH_DIRECTORY_WISDOM_PROGRAMS');
            this.getCampign();
            
            // If we have a mobile parameter, load the contact details
            if (this.$route.params.mobile) {
                this.search(this.$route.params.mobile);
            }
        }
        window.onpopstate = function () {
            if ($("body").hasClass("modal-open")) {
                location.reload();
            }
        };
    },
    methods: {
        displayAll() {
            this.search_qry = '';
            this.searchResponse.contact = '';
            this.searchResponse.message = '';
        },
        convertToJson(subject) {
            return JSON.parse(subject.replace(/&quot;/ig, '"'));
        },
        search(mobile = null) {
            if (mobile) {
                this.search_qry = mobile;
            }
            if (!this.search_qry) {
                return;
            }
            this.search_loading = true;
            let data = {
                q: this.search_qry,
                id: this.$route.params.id,
            }
            UserService.authPostRequest('get-call-campign-contact', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.search_loading = false;
                        this.searchResponse = response.data.data;
                        if (this.searchResponse.contact) {
                            this.formData.id = this.searchResponse.contact.contact_id;
                            this.formData.wisdom_member = this.searchResponse.contact.wisdom_member;
                            this.formData.name = this.searchResponse.contact.name;
                            this.formData.mobile = this.searchResponse.contact.mobile;
                            this.formData.mobile2 = this.searchResponse.contact.mobile2;
                            this.formData.sex = this.searchResponse.contact.gender;
                            this.formData.district = this.searchResponse.contact.district_id;
                            this.formData.place = this.searchResponse.contact.place;
                            this.formData.comments = this.searchResponse.contact.comments;
                            this.formData.status = this.searchResponse.contact.calling_status;
                            if (this.searchResponse.questian_responses) {
                                let count = 0;
                                this.searchResponse.questian_responses.forEach(element => {
                                    this.questians_responses[count] = element.answer_text;
                                    count++;
                                });
                            }
                            this.$root.updateParent('Call Campaign');
                        } 
                    } else {
                        this.search_loading = false;
                        this.alert_type = 'Error';
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                    }
                },
                (error) => {
                    this.search_loading = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code,
                type_id: id,
            };
            UserService.getCombobox(data).then(
                (response) => {
                    switch (code) {
                        case "CALL_CAMPAIGN_STATUS":
                            this.status_list = response.data.data.list.options;
                            break;
                        default:
                            break;
                    }
                },
                (error) => {
                    this.loading = false;
                    this.messafe =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        handleRegistration(data) {
            this.btn_loading = true;
            data.contact_id = data.id;
            data.id = this.searchResponse.contact.id;
            data.sex = this.formData.sex;
            data.campaign_id = this.searchResponse.contact.campaign_id;
            data.questians_responses = this.questians_responses;
            UserService.authPostRequest("store-campign-response", data).then(
                (response) => {
                    if (response.data.status == "success") {
                        this.pending_contacts = response.data.data.pending_contacts;
                        this.responseData.target = response.data.data.target;
                        this.responseData.balance = response.data.data.balance;
                        this.responseData.all_contacts = response.data.data.all_contacts;
                        this.alert_type = "Success";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.searchResponse.contact = '',
                            this.search_qry = '';
                        this.btn_loading = false;
                    } else if (response.data.status == "warning") {
                        this.alert_type = "Warning";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btn_loading = false;
                    } else {
                        this.alert_type = "Error";
                        this.alert_message = response.data.message;
                        this.$refs.alert_model.openModel();
                        this.btn_loading = false;
                    }
                },
                (error) => {
                    this.btn_loading = false;
                    this.message =
                        (error.response && error.response.data && error.response.data.message) ||
                        error.message ||
                        error.toString();
                }
            );
        },
        getCampign() {
            this.loading_list = true;
            let data = {
                id: this.$route.params.id,
                mobile: this.$route.params.mobile ? this.$route.params.mobile : null
            }
            UserService.authPostRequest('get-call-campign', data).then(
                (response) => {
                    if (response.data.status == 'success') {
                        this.loading_list = false;
                        this.responseData = response.data.data;
                        this.pending_contacts = response.data.data.pending_contacts;
                        this.all_contacts = response.data.data.all_contacts;
                        this.district_list = response.data.data.district;
                        if (this.responseData.questians) {
                            let count = 0;
                            this.responseData.questians.forEach(element => {
                                this.questians_responses[count] = element.answer_text;
                                count++;
                            });
                        }
                        this.$root.updateParent('Call Campaign');
                    } else {
                        this.loading_list = true;
                    }
                },
                (error) => {
                    this.loading_list = false;
                    this.alert_type = 'Error';
                    this.alert_message = error.data.message;
                    this.$refs.alert_model.openModel();
                }
            );
        },
        mobileToWhatsapp(mobileNumber) {
            // Remove any non-digit characters from the input
            const cleanNumber = mobileNumber.replace(/\D/g, '');

            // Check if the cleaned number has exactly 10 digits
            if (cleanNumber.length === 10) {
                // Add "91" to the beginning of the number
                return '91' + cleanNumber;
            } else {
                // If the number doesn't have 10 digits, return it as is
                return cleanNumber;
            }
        },
        gotoReport(mobile) {
            this.$router.push('/call-follow-up-V2/' + this.responseData.campign.reporting_campaign_id + '/' + mobile + '');
        },
        gotoEdit(mobile) {
            this.$router.push('/call-follow-up-edit/' + this.$route.params.id + '/' + mobile);
        }
    },
};
</script>

<style scoped>
.section-heading {
    padding: 10px 10px 0px 10px;
}

.error-feedback {
    color: red;
}

.listview {
    /* margin-bottom: 20px; */
}

.edit-btn {
    margin-left: 8px;
}

.progress {
    width: 80px;
}

.listview>li footer {
    color: #171617;
}

.min-width-50 {
    min-width: 60% !important;
}

.action-button-list>li {
    min-height: 1px !important;
}

.sl-no {
    font-weight: 900;
    margin-right: 12px;
}

.deleted-list-title {
    font-size: 15px;
}

.deleted-list {
    margin-bottom: 20px;
}

.deleted-info {
    background-color: #f2bbca;
    font-size: 12px;
}

.deleted-info strong {
    font-size: 18px;
    font-weight: 600;
}

.image-listview.text>li:after {
    left: 0px;
    /* height: 1px; */
    background-color: #1a418c;
}

.verification-badge {
    margin-left: 5px;
}

.avatar-section .button {
    color: #fff;
    width: 18px;
    height: 18px;
    border-radius: 100%;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    position: absolute;
    right: 10px;
    top: 24px;
    bottom: 0;
}

.avatar-section .verified {
    background: #4dc81c;
}

.avatar-section .not-verified {
    background: #eb3941;
}

.green-tick {
    font-size: 18px;
    color: darkgreen;
}

.red-cross {
    font-size: 18px;
    color: red;
}

.qhls-text {
    font-style: italic;
    color: #266bd1;
}

.custom-file-upload {
    position: relative;
    display: flex;
    width: 50%;
    height: 100px;
}
</style>
